import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "106.667",
  height: "106.667",
  viewBox: "0 0 80 80"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M303 785c-79-22-130-51-185-106C31 592-14 455 8 340 41 162 162 41 340 8c115-22 252 23 339 110 208 208 129 559-148 657-66 23-167 27-228 10m218-173c7-53 18-64 71-71 38-5 43-9 43-31s-5-26-43-31c-53-7-64-18-71-71-5-38-9-43-31-43s-26 5-31 43c-7 53-18 64-71 71-38 5-43 9-43 31s5 26 44 31c50 7 71 28 71 74 0 38 7 47 35 43 15-2 21-13 26-46m-286-62c0-18-6-26-23-28-13-2-25 3-28 12-10 26 4 48 28 44 17-2 23-10 23-28m67-207c7-25 16-34 41-41 41-11 41-33 0-44-25-7-34-16-41-41-10-40-42-50-42-13 0 31-24 56-56 56-17 0-24 5-24 20s7 20 24 20c32 0 56 25 56 56 0 37 32 27 42-13m268-98c15-18 10-45-12-59-35-22-74 27-48 59 16 19 44 19 60 0",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"},
      transform: "matrix(.1 0 0 -.1 0 80)"
    }, null, -1)
  ])))
}
export default { render: render }